export const SHIFTED_TEXT = 'shifted-text';
export const SHIFTED_TEXT_WITH_PADDING = 'shifted-text-with-padding';
export const SHIFTED_IMAGE = 'shifted-image';
export const BLOCK_PAGE_BREAK = 'block-page-break';
